export const hoursFromNow = (hours: number) => {
  const now = new Date();
  return now.setHours(now.getHours() + hours);
};
